// Minimal history-API router. No dependency; pages are plain async functions that
// render into #app. navigate() is used by in-app links and buttons.
type Route = (root: HTMLElement) => void | Promise<void>;

const routes = new Map<string, Route>();
let notFound: Route | undefined;

export function route(path: string, handler: Route): void {
  routes.set(path, handler);
}

export function setNotFound(handler: Route): void {
  notFound = handler;
}

export function navigate(path: string): void {
  if (path !== location.pathname) history.pushState({}, "", path);
  void render();
}

export async function render(): Promise<void> {
  const root = document.getElementById("app");
  if (!root) return;
  const handler = routes.get(location.pathname) ?? notFound ?? routes.get("/");
  if (handler) await handler(root);
}

window.addEventListener("popstate", () => {
  void render();
});
